import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { mdiClose } from '@mdi/js'
import { AppIcon } from '../ui/icon'
import { Button } from '../ui/button'
import { clearLoginRedirectNotice, readLoginRedirectNotice, type LoginRedirectNotice } from '../../lib/login-search'

// LoginRedirectedNotice tells a person who signed in on another
// organization's login page that the session opened in their own (spec
// 2026-10-14-22). The login page leaves the notice in sessionStorage; it is
// shown once, on the organization it names.
export function LoginRedirectedNotice({ org }: { org: string }) {
  const { t } = useTranslation('auth')
  const [notice, setNotice] = useState<LoginRedirectNotice | null>(() => readLoginRedirectNotice(org))

  useEffect(() => {
    const current = readLoginRedirectNotice(org)
    setNotice(current)
    if (current) clearLoginRedirectNotice()
  }, [org])

  if (!notice) return null
  return (
    <div
      className="mb-4 flex items-start gap-2 rounded-md border bg-muted p-3 text-sm text-foreground"
      role="status"
      data-testid="login-redirected-notice"
    >
      <p className="flex-1">{t('redirectedNotice.message', { from: notice.from, to: notice.to })}</p>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-6 w-6"
        aria-label={t('redirectedNotice.dismiss')}
        title={t('redirectedNotice.dismiss')}
        onClick={() => setNotice(null)}
        data-testid="login-redirected-notice-dismiss"
      >
        <AppIcon path={mdiClose} size="sm" />
      </Button>
    </div>
  )
}
